import { el } from 'redom';

import { stringToSVG } from 'utilities';

import './index.scss';

import duplicateNodeIconString from 'assets/images/duplicate-node-icon.svg?raw';

const duplicateNodeIcon = stringToSVG(duplicateNodeIconString);

class DuplicateObject {

  constructor(configuration) {

    this.onDuplicate = configuration.onDuplicate;

    this.el = el('button.inline-toolbar-button.duplicate-object-button', {
      type: 'button',
      onclick: this.handleClick.bind(this)
    }, [duplicateNodeIcon.cloneNode(true)]);

  }

  handleClick(event) {

    this.onDuplicate();

  }

}

export default DuplicateObject;